import { Box, chakra, Text } from '@chakra-ui/react';

export const DiscountNotice = ({
  discountCodes,
}: {
  discountCodes: string[];
}) => (
  <Box
    bg="greenAlpha.300"
    color="green.600"
    fontSize="sm"
    textAlign="center"
    borderTopRadius="base"
    py="5xs"
    px="3xs"
  >
    <Text size="detail" sx={{ fontVariantNumeric: 'slashed-zero' }}>
      {discountCodes.length > 1 ? (
        'Discount already applied'
      ) : (
        <>
          {'Discount '}
          <chakra.strong fontWeight="medium">
            {discountCodes[0]}
          </chakra.strong>{' '}
          applied
        </>
      )}
    </Text>
  </Box>
);
